import { render, staticRenderFns } from "./VerifiableCertificate.vue?vue&type=template&id=57fbd010&scoped=true&"
import script from "./VerifiableCertificate.vue?vue&type=script&lang=js&"
export * from "./VerifiableCertificate.vue?vue&type=script&lang=js&"
import style0 from "./VerifiableCertificate.vue?vue&type=style&index=0&id=57fbd010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fbd010",
  null
  
)

export default component.exports